import { Component, OnInit } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { URL_API } from '../constante';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

import { Upload } from '../uploads/upload';
import { UploadService } from '../uploads/upload.service';
import { DocumentoService } from '../documentos/documento.service';
import { Documento } from '../documentos/documento';

import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';


const URL = URL_API + '/envios';

@Component({
  selector: 'app-participantes',
  templateUrl: './upload.component.html',
  styleUrls: ['./participantes.css'],
  providers: [UploadService, DocumentoService]
})


export class UploadParticipantesComponent implements OnInit {
  public titulo: string = "Upload de Novos Participantes";
  public uploader: FileUploader = new FileUploader({url: URL});
  public upload: Upload;
  public documentos: Documento[];
  public erros: any;
  public busy: Promise<any>;
  public params:any = {nome: undefined};
  private searchSubject = new Subject<string>();
  private readonly debounceTimeMs = 500;

  constructor(private documentoService: DocumentoService,private uploadService: UploadService,
    private router: Router,
    private _flashMessagesService: FlashMessagesService) {
    this.upload = new Upload();
  }

  uploadArquivo(): void {
    this.erros = null;

    this.busy = this.uploadService.upload(this.upload)
          .then(() => this.goBack())
          .catch((error) => this.exibirMensagensdeErros(error));

  }

  _upload(event: any):void{
    let listaArquivo: FileList = event.target.files;
    let arquivo: File = listaArquivo[0];
    this.upload.arquivo = arquivo;
  }

  goBack(): void {
     this.router.navigate(['/listas-participantes']);
  }

  ngOnInit() {
   this.searchSubject.pipe(debounceTime(this.debounceTimeMs)).subscribe((searchValue) => {
    this.getDocumentos(searchValue);
  });
  }

  onSearch() {
    this.searchSubject.next(this.params.nome);
  }

  getDocumentos(searchValue: any = ""): void {
    let query = {page: 1, per_page: 10, nome: searchValue};   
    
    if (this.params['nome'] !== undefined){
      this.busy = this.documentoService.getDocumentos(query)
        .then(documentos => this.documentos = documentos['data']);
    }
  }

  

  exibirMensagensdeErros(error:any): void{
    this.erros = error.json().erros;
  }

}



// WEBPACK FOOTER //
// ./src/app/lista-participantes/upload.component.ts